<template>
    <el-card>
        <div slot="header">
            <span class="top_title">采购出入库</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span class="searchtips">日期:</span>
                <el-date-picker
                    v-model="searchDate.dateRan"
                    type="daterange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 230px"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
            <div class="search">
                <span class="searchtips">订单号:</span>
                <el-input v-model="searchDate.purid" placeholder="" style="width: 160px;" clearable></el-input>
            </div>
            <div class="search">
                <span class="searchtips">产品:</span>
                <el-input v-model="searchDate.product" placeholder="" style="width: 160px;" clearable></el-input>
            </div>
            <div class="search">
                <span class="searchtips">业务类型:</span>
                <el-select v-model="searchDate.type" clearable style="width:160px">
                    <el-option value="1" label="入库"></el-option>
                    <el-option value="2" label="出库"></el-option>
                </el-select>
            </div>
            <div class="search">
                <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;
            "
            border
            show-summary
            :summary-method="getSummaries"
        >
            <el-table-column label="操作" align="center">
                <template slot-scope="{row}">
                    <el-button type="text" @click="del(row.id)" v-if="$common.hasLimits('materialRecordDelete')">删除</el-button>
                </template>
            </el-table-column>
            <template v-for="(col, index) in cols">
				<el-table-column 
					:key="index"
					:prop="col.prop" 
					:label="col.label" 
					:width="col.width"
					:min-width="col.min_width"
					align="left"
				>
					<template #header v-if="col.column">
						{{col.label}}
						<el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
					</template>
					<template slot-scope="{ row }">
						<div>{{row[col.prop]}}</div>
					</template>
				</el-table-column>
			</template>
        </el-table>
        <el-pagination
            style="text-align: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 120, 250]"
            :page-size="cp_pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
        >
        </el-pagination>
    </el-card>
</template>

<script>
export default {
    components:{
    },
    data(){
        return{
            searchDate: {
                dateRan: "",
                purid:"",
                product:'',
                type:"",
                column:'',
				order:'',
            },
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
            tableData:[],
            total:0,
            currentPage:1,
            cp_pagesize:20,
            nowSearch:{
                limit:20,
                page:1,
            },
            amountSum:0,
            moneySum:0,
            cols:[
                {
                    label:'日期',
                    prop:'cdate',
                    column:'cdate',
                    width:'180',
                },{
                    label:'业务类型',
                    prop:'actype',
                },{
                    label:'产品',
                    prop:'name',
                    column:'mnumber',
                    width:'180',
                },{
                    label:'属性1',
                    prop:'mspec1',
                },{
                    label:'属性2',
                    prop:'mspec2',
                },{
                    label:'单价',
                    prop:'price',
                    column:'price',
                    width:'180',
                },{
                    label:'数量',
                    prop:'amount',
                    column:'amount',
                    width:'180',
                },{
                    label:'总价',
                    prop:'money',
                    column:'money',
                    width:'180',
                },{
                    label:'订单号',
                    prop:'onumber',
                    column:'onumber',
                    width:'180',
                },
            ]
        }
    },
    created(){
        this.getInfo();
    },
    methods: {
        getSummaries() {
            return ['合计',,,,,,,this.amountSum,this.moneySum];
        },
        searchOrder(){
            this.currentPage = 1;
            this.nowSearch = {
                limit:this.cp_pagesize,
                page:1,
            }
            if(this.searchDate.dateRan&&this.searchDate.dateRan.length>=2){
                this.nowSearch.start = this.searchDate.dateRan[0];
                this.nowSearch.end = this.searchDate.dateRan[1];
            }
            if(this.searchDate.purid.length>0){
                this.nowSearch.onumber = this.searchDate.purid;
            }
            if(this.searchDate.type>0){
                this.nowSearch.type = this.searchDate.type;
            }
            if(this.searchDate.product.length>0){
                this.nowSearch.mname = this.searchDate.product;
            }
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.nowSearch.column = this.searchDate.column;
                this.nowSearch.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.nowSearch.column;
                delete this.nowSearch.order;
            }
            this.getInfo();
        },
        getInfo(){
            this.$api.listRecord(this.nowSearch).then(res=>{
                if(res.data.code==1){
                    res.data.data.data.forEach(e => {
                        e.name = "["+e.mnumber+"]"+e.mname;
                        e.actype = e.type==1?'入库':'出库';
                    });
                    this.tableData = res.data.data.data;
                    this.total = res.data.data.total;
                    this.amountSum = res.data.data.amountSum;
                    this.moneySum = res.data.data.moneySum;
                }
            })
        },
        handleSizeChange(e){
            this.cp_pagesize = e;
            this.searchOrder();
        },
        handleCurrentChange(e){
            this.currentPage = e;
            this.nowSearch.page = e;
            this.getInfo();
        },
        del(id){
            if(!id){
                return;
            }
            this.$api.deleteRecord({deleteId:id}).then(res=>{
                if(res.data.code==1){
                    if(this.tableData.length==1&&this.currentPage>1){
                        this.currentPage = 1;
                    }
                    this.$notify({
                        title: "删除数据",
                        message: "删除成功",
                        type: "success",
                        duration: 1000,
                    });
                    this.getInfo();
                }
            })
        },
    }
}
</script>